import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 64 — GoHighLevel product-feature cluster service links.
 *
 * Every Batch 64 article routes its primary commercial link to
 * /gohighlevel-revops-architect. The answer-first leads in batch64Content.ts
 * embed the link directly, but the lead-swap idempotency guard can drop the
 * lead when the Quick Answer duplicates the lead text. This map is the
 * RELIABLE fallback: `injectBatchServiceLink` (batchContentOptimizer.ts) wraps
 * the first in-body occurrence of each anchor phrase in a
 * /gohighlevel-revops-architect link, so the contextual service link always
 * renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH64_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "gohighlevel-snapshot-guide": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /one-off build with no snapshot is a build the team rekeys by hand/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-ai-employee-setup": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /AI Employee with no guardrail is an AI Employee that books the wrong appointment/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-saas-mode-setup": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /SaaS Mode with no pricing logic is a SaaS Mode that underbills the client/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-sub-account-setup": {
    url: "/gohighlevel-revops-architect",
    anchor: /build in the agency view is a build the client cannot own/i,
    label: "hire a GoHighLevel RevOps architect",
  },
};
